import React from 'react'
import { NotificationUnreadLines } from 'solar-icons'

import { Hint } from '@/components/ui'

export const SearchPlaceholder = () => {
  return (
    <div className="flex flex-grow flex-col items-center justify-center gap-4 rounded-lg px-4 md:px-0">
      <NotificationUnreadLines
        className="size-20 text-gray-200"
        strokeWidth={0.6}
      />
      <div className="flex flex-col items-center gap-2 text-center">
        <span className="text-base font-medium">
          Enter your search query to find products
        </span>
        <Hint variant="info" className="flex-col">
          Hint: You can search products by Name, Barcode, or SKU
        </Hint>
      </div>
    </div>
  )
}
